import { AAGUID } from '@interticket/core';
import { IChannelSettings } from '../../interfaces/event/event-channel-settings.interface';
import { DefaultChannelSettings } from './event-default-channel-settings.model';

export class ChannelSettings extends DefaultChannelSettings implements IChannelSettings {

  readonly channelId: AAGUID;

  constructor(iChannelSettings: IChannelSettings) {
    super(iChannelSettings);
    this.channelId = iChannelSettings.channelId;
  }

}
